import get from 'lodash/get';
import isNil from 'lodash/isNil';

import { CONSENT_MODE_UNSPECIFIED } from 'api/consent-modes/modes';
import effectiveConsentMode from 'api/consent-modes/utils/effectiveConsentMode';

/**
 * Normalize a deployed integration's consent payload to the shape used by
 * deploy-status comparators (matches the staged-side Hasura shape).
 *
 * Applies effectiveConsentMode so the output is directly comparison-ready:
 * CONSENT_MODE_UNSPECIFIED (protobuf default) is coerced to ACE before being returned.
 *
 * @param {{ category?: string, mode?: string } | null | undefined} consent
 * @returns {{ consentCategoryCode: string | null, consentMode: string | null }}
 */
export default function resolveDeployedConsent(consent) {
  // pipeline.consent.category is a protobuf string and returns '' when empty
  // Coerce '' to null so it matches the staged-side Hasura shape (null when no category).
  const consentCategoryCode = get(consent, 'category') || null;

  let rawConsentMode = null;

  if (!isNil(consentCategoryCode)) {
    // ACE consentMode integration with category
    // if pipeline was deployed before consentMode existed, it will be CONSENT_MODE_UNSPECIFIED (treated as ACE)
    rawConsentMode = get(consent, 'mode', CONSENT_MODE_UNSPECIFIED);
  } else {
    // Two scenarios collapse into this branch:
    // - Legacy consent with no consent object at all
    // - External consent that does not have a category
    rawConsentMode = get(consent, 'mode') || null;
  }

  return {
    consentCategoryCode,
    consentMode: effectiveConsentMode(rawConsentMode),
  };
}
